import { prependProxyBaseUrl, request } from "api/request";

export const deleteFile = async (id: string) => {
  return request()
    .url(prependProxyBaseUrl(`/api/media/internal/delete-file/${id}`))
    .delete()
    .res();
};
